import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip,
} from "@mui/material";
import * as FileSaver from "file-saver";
import { useState } from "react";
import download from "../../assets/images/csv.png";

export const ExportCSV = ({ csvData, fileName }) => {
  const [open, setOpen] = useState(false);

  const fileExtension = ".csv";
  
  const handleExportCsv = async () => {
    let csv = "";
    csvData.forEach(({ data, key }) => {
      if (data.length !== 0) {
        csv += `"${key}"\n`;
        const headers = Object.keys(data[0]);
        csv += `"${headers.join('","')}"\n`;
        data.forEach((row) => {
          const values = Object.values(row);
          csv += `"${values.join('","')}"\n`;
        });
        csv += "\n";
      }
    });
    
    if (csv === "") {
      setOpen(true);
    } else {
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      FileSaver.saveAs(blob, fileName + fileExtension);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Tooltip title="CSV Export ">
        <Button className="chart-action-button" onClick={handleExportCsv}>
          <img src={download} alt="CSV export" />
          CSV
        </Button>
      </Tooltip>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>No data found</DialogTitle>
        <DialogContent>
          <DialogContentText>
            There is no data available, the file will be empty.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>OK</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
